import r from "./loadPlugins.js";
import o, { useImperativeHandle as n } from "react";
import { getInitialOptionsFromProps as t } from "./utils/options.js";
import { useControl as a } from "./hooks/advanced/control.js";
var i = o.forwardRef(function (o, i) {
  var e = a({
    prepare: function prepare() {
      return r("AMap.ControlBar");
    },
    init: function init(r) {
      var n = t(o);
      return new r.ControlBar(n);
    }
  }, o);
  return n(i, function () {
    return e;
  }, [e]), null;
});
export default i;